import { LuLightbulb, LuChevronDown, LuChevronRight } from "react-icons/lu";
import * as styled from "./GeneralDropDown.styled"

// Заголовок акордеона. icon — іконка з react-icons; withoutArrow — це посилання, а не акордеон
function GeneralDropDown({ setOpen, open, title, withoutArrow, icon: Icon = LuLightbulb }) {
  return (
    <styled.DropDown
      onClick={() => {
        if (!setOpen) return
        setOpen(prev => !prev)
      }}
      $open={open}
    >
      <styled.IconWrapper>
        <Icon size={20} />
      </styled.IconWrapper>
      <styled.DropDownTitle>{title}</styled.DropDownTitle>
      <styled.Chevron $open={open}>
        {withoutArrow ? <LuChevronRight size={20} /> : <LuChevronDown size={20} />}
      </styled.Chevron>
    </styled.DropDown>
  )
};

export default GeneralDropDown;
